import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import LocationParentsView from './ui/LocationParentsView';
import LocationPersonList from './LocationPersonList';
import PersonList from './PersonList';
import AudioList from './AudioList';
import SagnirList from './SagnirList';
import EventsList from './EventsList';
import LocationThingList from './LocationThingList';
import TabContainer from './ui/TabContainer';
import Breadcrumb from './ui/Breadcrumb';
import MapView from './MapView';
import InterviewList from './InterviewList';
import LoadingBar from './ui/LoadingBar';
import BookmarkButton from './ui/BookmarkButton';
import LocationsMap from './LocationsMap';
import TextDisplay from './ui/TextDisplay';
import LinkList from './ui/LinkList';
import PlaceList from './PlaceList';
import ProjectEntryList from './ProjectEntryList';
import ImageList from './ui/ImageList';
import MediaList from './ui/MediaList';
import NotFound from './ui/NotFound';
import LinkedLbsSources from './ui/LinkedLbsSources';
import {Helmet} from 'react-helmet';

import _ from 'underscore';

import config from './../config';
import helpers from './../lib/helpers';

class PlaceView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			hideAudioList: false,
			hideAudioMentionList: false,
			hideLocationPersonList: false,
			hideSagnirList: false,
			hideInterviewList: false,
			hideEventsList: false,
			hideThingList: false,
			hideChildPlaceList: false,
			hideProjectEntryList: false,
			notFound: false,
			loading: true
		}
	}


	componentDidMount() {
		if (this.props.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			hideAudioList: false,
			hideAudioMentionList: false,
			hideLocationPersonList: false,
			hideSagnirList: false,
			hideProjectEntryList: false,
			hideInterviewList: false,
			hideEventsList: false,
			hideThingList: false,
			hideChildPlaceList: false,
			notFound: false,
			loading: true
		});

		helpers.fetch(config.apiRoot+'/api/locations/'+this.props.match.params.id, (json) => {
			if (json.notfound) {
				this.setState({
					notFound: true,
					loading: false
				});

				return;
			}

			if (!helpers.isNumber(this.props.match.params.id) && json.id) {
				this.props.history.replace(helpers.routerUrls['stadir']+json.id)

				return;
			}
			this.setState({
				data: json,
				loading: false
			});
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	render() {
		if (this.state.notFound) {
			return <NotFound />
		}
		else {
			let images = this.state.data && this.state.data.files && this.state.data.files.length > 0 ? _.filter(this.state.data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png')) : [];
			let otherFiles = this.state.data && this.state.data.files ? _.reject(this.state.data.files, (item) => item.extension == 'jpg') : [];

			let tabContainer = this.state.data ? <TabContainer useRouter={'true'} selectedTab={this.props.match.params.tab} baseUrl={helpers.routerUrls['location']+this.props.match.params.id}>

				<PlaceList parentId={this.props.match.params.id}
					tabname="stadir"
					tabtitle={'Staðir'}
					hideAsTab={this.state.hideChildPlaceList}
					searchParams={this.props.searchParams}
					useRouter={false}
					disableMap={false}
					onResponse={(data) => {
						this.setState({
							hideChildPlaceList: data.length == 0
						})
					}}
				>
					<p className="mb-3"><small>Staðir sem tilheyra þessum stað.</small></p>
				</PlaceList>

				<AudioList locationId={this.props.match.params.id}
					tabname="hljodrit"
					tabtitle={'Hljóðrit'}
					hideAsTab={this.state.hideAudioList}
					searchParams={this.props.searchParams}
					onResponse={(data) => {
						this.setState({
							hideAudioList: data.length == 0
						})
					}}
				>
					<p className="mb-3"><small>Hljóðrit frá þessum stað.</small></p>
				</AudioList>

				<AudioList tabtitle={'Minnst á í hljóðritum'}
					tabname="stadir_minnst_a"
					minnst_a_stad={this.props.match.params.id}
					disablePlayButtonRouteChange={true}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideAudioMentionList}
					onResponse={(response) => {
						this.setState({
							hideAudioMentionList: response.length == 0 || !response
						});
				   }}
				>
					<p><small>
						Hljóðrit þar sem minnst er á þennan stað.
					</small></p>
				</AudioList>

				<LocationPersonList locationId={this.props.match.params.id}
					tabname="einstaklingar"
					tabtitle={'Einstaklingar'}
					hideAsTab={this.state.hideLocationPersonList}
					searchParams={this.props.searchParams}
					onResponse={(data) => {
						this.setState({
							hideLocationPersonList: data.length == 0
						})
					}}
				>
					<p className="mb-3"><small>Fólk tengt þessum stað eða stöðum innan hans ef um stærra svæði er að ræða.</small></p>
				</LocationPersonList>

				<SagnirList tabtitle={'Sagnir og ævintýri'}
					tabname="tjodfraedi"
					locationId={this.props.match.params.id}
					hideAsTab={this.state.hideSagnirList}
					searchParams={this.props.searchParams}
					onResponse={(data) => {
						this.setState({
							hideSagnirList: data.length == 0
						})
				   }}
				>
					<p className="mb-3"><small>Þjóðfræðiefni þar sem minnst er á þennan stað eða staði innan hans ef um stærra svæði er að ræða.</small></p>
				</SagnirList>

				<ProjectEntryList tabtitle={'Verkefnisgögn'}
					tabname="verkefni"
					locationId={this.props.match.params.id}
					hideAsTab={this.state.hideProjectEntryList}
					onResponse={(data) => {
						this.setState({
							hideProjectEntryList: data.length == 0
						})
				   }}
				>
					<p className="mb-3"><small>Verkefnisgögn tengd þessum stað eða staði innan hans ef um stærra svæði er að ræða.</small></p>
				</ProjectEntryList>

				<InterviewList tabtitle={'Viðtöl'}
					tabname="vidtol"
					locationId={this.props.match.params.id}
					hideAsTab={this.state.hideInterviewList}
					onResponse={(data) => {
						this.setState({
							hideInterviewList: data.length == 0
						})
				   }}
			   >
					<p className="mb-3"><small>Viðtöl tekin á þessum stað eða stöðum innan hans ef um stærra svæði er að ræða.</small></p>
				</InterviewList>

				<EventsList tabtitle={'Viðburðir'}
					tabname="vidburdir"
					locationId={this.props.match.params.id}
					hideAsTab={this.state.hideEventsList}
					onResponse={(data) => {
						this.setState({
							hideEventsList: data.length == 0
						})
				   }}
			   >
					<p className="mb-3"><small>Viðburðir haldnir á þessum stað.</small></p>
				</EventsList>

				<LocationThingList tabtitle={'Orgel'}
					tabname="orgel"
					locationId={this.props.match.params.id}
					hideAsTab={this.state.hideThingList}
					onResponse={(data) => {
						this.setState({
							hideThingList: data.length == 0
						})
				   }}
			   >
					<p className="mb-3"><small>Orgel tengd þessum stað.</small></p>
				</LocationThingList>

				{
					this.state.data.links && this.state.data.links.length > 0 &&
					<LinkList tabtitle={'Tenglar'}
						tabname="tenglar"
						data={this.state.data.links}>
						<p className="mb-3"><small>Tengt efni á öðrum vefjum.</small></p>
					</LinkList>
				}

				{
					otherFiles && otherFiles.length > 0 &&
					<MediaList tabtitle={'Tengdar skrár'}
						tabname="skrar"
						data={otherFiles}>
						<p className="mb-3"><small>Tengdar skrár.</small></p>
					</MediaList>
				}

			</TabContainer> : null;

			return <div className={'content-container position-relative '+(this.state.loading ? ' loading' : '')}>
				<LoadingBar />
				{
					this.state.data &&
					<React.Fragment>
						<Breadcrumb currentElTitle={this.state.data.name} />

						<Helmet>
							<meta property="og:type"
								content="article"
							/>
							<meta property="og:title"
								content={'Ísmús | '+this.state.data.name}
							/>
							{
								this.state.data.parent &&
								<meta property="og:description"
									content={_.pluck(this.state.data.parent, 'name').join(' / ')}
								/>
							}
							{
								images && images.length > 0 &&
								<meta property="og:image"
									content={config.mediaUrl+images[0].path}
								/>
							}
							{
								(!images || images.length == 0) &&
								<meta property="og:image" content='//ismus.is/img/share-image.png' />
							}
						</Helmet>

						<div>
							<BookmarkButton id={this.state.data.id} title={this.state.data.name} type="location" className="float-right" />
							<h2>{this.state.data.name}
								{
									this.state.data.aka &&
									<React.Fragment>
										<br/>
										<small>{this.state.data.aka.split('\n').join(', ')}</small>
									</React.Fragment>
								}
							</h2>
							{
								((this.state.data.location_type && this.state.data.location_type.id) || this.state.data.parent) &&
								<div className="mb-3">
									{
										this.state.data.location_type && this.state.data.location_type.id &&
										helpers.metadataList([this.state.data.location_type], helpers.routerUrls['stadir']+'?tegund=', 'id', 'name')
									}
									{
										this.state.data.location_type && this.state.data.location_type.id && this.state.data.parent && <React.Fragment> | </React.Fragment>
									}
									{
										this.state.data.parent &&
										<LocationParentsView location={this.state.data} skipFirst={true} />
									}
								</div>
							}
						</div>

						<div className="row">
							<div className={'col-12'+(images.length > 0 ? ' col-md-8' : '')}>
								{
									this.state.data.text &&
									<TextDisplay className="mb-4" maxHeight={500} text={this.state.data.text} />
								}

								{
									this.state.data.lat && this.state.data.lng &&
									<MapView className="small mb-2"
										mapData={[{
											label: this.state.data.name,
											district: helpers.createLocationParentString(this.state.data.parent),
											id: this.state.data.id,
											latLng: [this.state.data.lat, this.state.data.lng]
										}]} />
								}

								{
									images.length > 12 &&
									tabContainer
								}
							</div>

							{
								images &&
								<div className={'col-12 '+(this.state.data.text || this.state.data.lat ? 'col-md-4' : '')}>
									<ImageList data={images} />
								</div>
							}

						</div>

						{
							images.length <= 12 &&
							<div className="row">

								<div className={'col-12'}>
									{
										tabContainer
									}
								</div>

							</div>
						}

						{/*
							data.copy && data.copy.id &&
							<div className="mt-5">
								<h4 className="mb-3">Fleiri hljóðrit með sama safnmarki</h4>
								<AudioList copyId={this.state.data.copy.id} hightlightId={this.state.data.id} />
							</div>
						*/}

						{
							this.state.data.lbs_key && <LinkedLbsSources current="ismus" lbs_key={this.state.data.lbs_key} />
						}

						{
							this.state.data.modification_date &&
							<p className="mt-4 small">Síðast breytt {helpers.formatDate(this.state.data.modification_date, false, true)}</p>
						}

						</React.Fragment>
				}
				</div>
		}
	}
}

export default withRouter(PlaceView);
